/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_RatingInputs */



/**
* | output |
* | --- |
* | "Rating" |
*
* @param {Subtitle_Export_Vchip_RatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_rating = /** @type {((inputs?: Subtitle_Export_Vchip_RatingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_RatingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bewertung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Valutazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Рейтинг")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clasificación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("等级")
	if (locale === "ja") return /** @type {LocalizedString} */ ("評価")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रेटिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avaliação")
	return /** @type {LocalizedString} */ ("Rating")
});